import React from 'react';
import UnifiedResetPassword from '@components/UnifiedResetPassword';
import { getHostname } from '@services/utils';

const ResetPassword: React.FC = () => {
  const hostname = getHostname();
  const theme = hostname.includes('dxscontrols') ? 'light' : 'dark';

  return <UnifiedResetPassword theme={theme} />;
};

export default ResetPassword;
